import styled, { css } from 'styled-components';

export const MainImageStyles = styled.div`
  position: relative;
  height: 450px;
  margin: 0px 1px 1px;

  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  @media (max-width: 1024px) {
    height: 600px;
  }

  @media (max-width: 900px) {
    height: 500px;
  }

  @media (max-width: 768px) {
    height: 400px;
  }

  @media (max-width: 600px) {
    height: 300px;
  }
`;

export const Arrow = styled.div`
  cursor: pointer;
  content: '';
  display: none;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100px;

  ${({ isHovered }) =>
    !!isHovered &&
    css`
      display: flex;
    `}

  @media (max-width: 512px) {
    display: flex;
  }
`;

export const LeftArrow = styled(Arrow)`
  left: 0;
`;

export const RightArrow = styled(Arrow)`
  right: 0;
`;
